import React, { useContext } from 'react'
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ImgHero from "../../Assets/Images/cashbox_double_2.png"
import { TypeAnimation } from 'react-type-animation';
import { Context } from "../../Context/LangContext"
function Header() {
  const { lang } = useContext(Context)
  return (
    <header id='main' className={`site-header`}>
      <div data-aos="flip-down" className='xl:container mx-auto flex flex-col lg:flex-row items-center justify-center px-5 xl:px-0 pb-[120px] pt-[120px] xl:pt-[200px]'>
        <div className='text-center lg:text-left lg:w-[570px]'>
          <h2 className='text-[30px] sm:text-[52px] mb-5 font-bold leading-[32px] sm:leading-[60px] text-white flex flex-col sm:flex-row sm:space-x-3 lg:space-x-0 lg:flex-col '>
            <span>CASHBOX</span>
            <TypeAnimation
              sequence={[
                `${lang ? "TERMINAL" : "ТЕРМИНАЛ"}`,
                1000,
                `${lang ? "SMART KASSA" : "СМАРТ КАССА"}`,
                2000,
                `${lang ? "ONLINE KASSA" : "ОНЛАЙН КАССА"}`
                ,
                () => {
                }
              ]}
              wrapper="span"
              cursor={true}
              repeat={Infinity}
              style={{ display: 'inline-block', color: "#40E0EE" }}
            />
          </h2>
          <p className='text-white'>{lang ? "To'lov qurilmalarining keyingi avlodi kassa + terminal" : "Следующее поколение платежных устройств касса + терминал"} </p>
        </div>
        <img data-aos="zoom-in-up" alt='' src={ImgHero} width={492} height={558} />
      </div>
      <a href={'/#main'} className='w-[42px] z-50 rotate-90 duration-200 fixed right-5 bottom-5 h-[42px] text-white flex items-center justify-center rounded-[50%] bg-[#00C9DB] hover:bg-[#73e5f0]'>
        <ArrowBackIosNewIcon />
      </a>
    </header >
  )
}


export default Header